export const matrixColumns = (columns) => {
    return columns.map(column => {
        let newColumn = {...column}
        if (!newColumn.display_name)
            newColumn.display_name = newColumn.name
        return newColumn
    })
}
